import { createSlice } from '@reduxjs/toolkit';
import { GET_CURRENT_CYCLE_DETAILS } from '../../actions/GetCurrentCycleDetails/GetCurrentCycleDetailsType';

const initialState = {
  cycleDetails: {
    isLoading: false,
    // data: {
    data: null,
    errors: '',
    message: ''
  }
};

export const getCurrentDetailsSlice = createSlice({
  name: 'getCurrentDetails',
  initialState,
  reducers: {
    getCurrentCycleDetails: (state, action) => {
        console.log('cycle detail')
      if (action.payload) {
        state.cycleDetails.data = action.payload;
      }
      state.cycleDetails.isLoading = false;
    },
    setCurrentCycleFailureAction: (state, action) => {
      state.cycleDetails.isLoading = false;
      state.cycleDetails.errors = action.payload;
    }
  }
});

export const { getCurrentCycleDetails, setCurrentCycleFailureAction } = getCurrentDetailsSlice.actions;

export default getCurrentDetailsSlice.reducer;
